import { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import './orderDetails.css'
import MediumModal from '../components/Modal/MediumModal'
import BigModal from '../components/Modal/BigModal'

const GET_ORDER_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getOrder'
const EDIT_ORDER_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/editOrder'
const GET_ORDER_STATUS_HISTORY_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getOrderStatusHistory'
const UPDATE_ORDER_STATUS_HISTORY_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/updateOrderStatusHistory'
const GET_PRODUCTS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getProducts'
const GENERATE_OFFER_PDF_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/generateOfferPdf'


const ORDER_STATUSES = [
    'solicitare',
    'ofertat',
    'acceptat',
    'asteptare_plata',
    'comanda_furnizor',
    'pregatire_colet',
    'expediat',
    'finalizat',
    'refuzat'
]
const ORDER_STATUS_LABELS = {
    solicitare: 'Solicitare',
    ofertat: 'Ofertat',
    acceptat: 'Acceptat',
    asteptare_plata: 'Așteptare plată',
    comanda_furnizor: 'Comandă furnizor',
    pregatire_colet: 'Pregătire colet',
    expediat: 'Expediat',
    finalizat: 'Finalizat',
    refuzat: 'Refuzat'
}
const ORDER_STATUS_ICONS = {
    solicitare: '●',
    ofertat: '●',
    acceptat: '✓',
    asteptare_plata: '◷',
    comanda_furnizor: '🛒',
    pregatire_colet: '📦',
    expediat: '🚚',
    finalizat: '⚑',
    refuzat: '×'
}
const PRODUCT_STATUSES = [
    'ofertat',
    'acceptat',
    'comandat',
    'primit',
    'refuzat'
]

const PRODUCT_STATUS_ORDER = {
    ofertat: 1,
    acceptat: 2,
    comandat: 3,
    primit: 4,
    refuzat: 5
}
const PRODUCT_STATUS_LABELS = {
    toate: 'Toate',
    ofertat: 'Ofertat',
    acceptat: 'Acceptat',
    refuzat: 'Refuzat',
    comandat: 'Comandat',
    primit: 'Primit'
}
const ACCEPTED_PRODUCT_STATUSES = [
    'acceptat',
    'comandat',
    'primit'
]
const PAYMENT_METHOD_OPTIONS = [
    {
        value: '',
        label: 'Selectează metoda de plată'
    },
    {
        value: 'plata_in_avans',
        label: 'Plată în avans'
    },
    {
        value: 'plata_la_termen_15_zile',
        label: 'Plată la termen - 15 zile'
    },
    {
        value: 'plata_la_termen_30_zile',
        label: 'Plată la termen - 30 zile'
    },
    {
        value: 'plata_la_curier',
        label: 'Plată la curier'
    }
]

const DELIVERY_TERM_OPTIONS = [
    {
        value: '',
        label: 'Selectează termenul de livrare'
    },
    {
        value: '1_3_zile',
        label: '1-3 zile'
    },
    {
        value: '3_5_zile',
        label: '3-5 zile'
    },
    {
        value: '5_7_zile',
        label: '5-7 zile'
    },
    {
        value: '7_10_zile',
        label: '7-10 zile'
    },
    {
        value: '10_15_zile',
        label: '10-15 zile'
    },
    {
        value: '15_30_zile',
        label: '15-30 zile'
    }
]
function formatDate(dateString) {
    if (!dateString) {
        return '-'
    }

    const cleanDate = String(dateString)
        .replace('T', ' ')
        .replace('.000Z', '')
        .replace('Z', '')

    const [datePart, timePart = '00:00:00'] = cleanDate.split(' ')
    const [year, month, day] = datePart.split('-')
    const [hour = '00', minute = '00'] = timePart.split(':')

    return `${day}.${month}.${year} • ${hour}.${minute}`
}
function OrderDetails() {
    const navigate = useNavigate()
    const { clientSlug, orderUuid } = useParams()

    const [orderData, setOrderData] = useState(null)
    const [loading, setLoading] = useState(true)
   const [saving, setSaving] = useState(false)
const [savingOrderStatus, setSavingOrderStatus] = useState(false)
const [savingCommercialDetails, setSavingCommercialDetails] = useState(false)
    const [generatingOffer, setGeneratingOffer] = useState(false)
    const [error, setError] = useState('')
    const [selectedProducts, setSelectedProducts] = useState([])
    const [orderStatus, setOrderStatus] = useState('')
    const [bulkProductStatus, setBulkProductStatus] = useState('ofertat')
    const [openProducts, setOpenProducts] = useState([])
    const [statusDropdownOpen, setStatusDropdownOpen] = useState(false)
    const [productStatusFilter, setProductStatusFilter] = useState('toate')
    const [productsPage, setProductsPage] = useState(1)
    const [productsPerPage, setProductsPerPage] = useState(20)
    const statusDropdownRef = useRef(null)
    const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false)
    // const [furnizori, setFurnizori] = useState([])
    const [savingProduct] = useState(false)
    const [allProducts, setAllProducts] = useState([])
    const [productSearchResults, setProductSearchResults] = useState([])
    const [isAddSupplierModalOpen, setIsAddSupplierModalOpen] = useState(false)
    // const [activeSupplierProductId, setActiveSupplierProductId] = useState(null)

    const [addProductsForm, setAddProductsForm] = useState([])
    const [orderStatusHistory, setOrderStatusHistory] = useState([])
    const [collapsedSupplierSections, setCollapsedSupplierSections] = useState({})

    const [dirtyProductIds, setDirtyProductIds] = useState([])

    const [paymentMethod, setPaymentMethod] = useState('')
    const [orderDeliveryTerm, setOrderDeliveryTerm] = useState('')
    const [orderCommercialDetailsChanged, setOrderCommercialDetailsChanged] = useState(false)

    // const [productForm, setProductForm] = useState({
    //     nume: '',
    //     imagine: '',
    //     cod_produs: '',
    //     serie_produs: '',
    //     ean: '',
    //     garantie: '',
    //     termen_livrare: '',
    //     cantitate: 1,
    //     pret_ofertat: ''
    // })

    // const [productSuppliersForm, setProductSuppliersForm] = useState([
    //     {
    //         furnizor_id: '',
    //         link_produs: '',
    //         pret_furnizor: '',
    //         cantitate_disponibila: '',
    //         cantitate: 1
    //     }
    // ])


    // async function getFurnizori() {
    //     const response = await fetch(GET_SUPPLIERS_API_URL)
    //     const data = await response.json()
    //     setFurnizori(Array.isArray(data.suppliers) ? data.suppliers : [])
    // }

    function openAddProductModal() {
        setAddProductsForm([])
        setProductSearchResults({})
        setCollapsedSupplierSections({})
        getAllProductsForOrderDetails()
        setIsAddProductModalOpen(true)
    }
    function addEmptyProductToOrderModal() {
        const tempId = `new-order-product-${Date.now()}`

        setAddProductsForm((prev) => [
            ...prev,
            {
                tempId,
                produs_id: null,
                search: '',
                nume: '',
                cod_produs: '',
                serie_produs: '',
                ean: '',
                imagine: '',
                garantie: '',
                termen_livrare: '',
                cantitate: 1,
                pret_ofertat: '',
                furnizori: []
            }
        ])
    }

    function removeProductFromOrderModal(index) {
        setAddProductsForm((prev) => prev.filter((_, productIndex) => productIndex !== index))
    }

    function updateAddProductField(index, field, value) {
        setAddProductsForm((prev) =>
            prev.map((product, productIndex) =>
                productIndex === index
                    ? { ...product, [field]: value }
                    : product
            )
        )
    }

    function updateAddProductSupplier(productIndex, supplierIndex, field, value) {
        setAddProductsForm((prev) =>
            prev.map((product, currentProductIndex) =>
                currentProductIndex === productIndex
                    ? {
                        ...product,
                        furnizori: (product.furnizori || []).map((supplier, currentSupplierIndex) =>
                            currentSupplierIndex === supplierIndex
                                ? { ...supplier, [field]: value }
                                : supplier
                        )
                    }
                    : product
            )
        )
    }

    function toggleProductSuppliers(productKey) {
        setCollapsedSupplierSections((prev) => ({
            ...prev,
            [productKey]: !prev[productKey]
        }))
    }

    function searchAddOrderProduct(index, value) {
        setAddProductsForm((prev) =>
            prev.map((product, productIndex) => {
                if (productIndex !== index) {
                    return product
                }

                return {
                    ...product,
                    produs_id: null,
                    search: value,
                    nume: value,
                    cod_produs: '',
                    serie_produs: '',
                    ean: '',
                    imagine: '',
                    garantie: '',
                    termen_livrare: '',
                    furnizori: []
                }
            })
        )

        const cleanValue = value.trim().toLowerCase()

        if (cleanValue.length < 2) {
            setProductSearchResults((prev) => ({
                ...prev,
                [index]: []
            }))
            return
        }

        const results = allProducts
            .filter((product) => {
                const searchableText = [
                    product.nume,
                    product.cod_produs,
                    product.serie_produs,
                    product.ean
                ]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()

                return searchableText.includes(cleanValue)
            })
            .slice(0, 30)

        setProductSearchResults((prev) => ({
            ...prev,
            [index]: results
        }))
    }

    function selectAddOrderProduct(index, product) {
        const productSuppliers = Array.isArray(product.furnizori) ? product.furnizori : []

        setAddProductsForm((prev) =>
            prev.map((item, productIndex) =>
                productIndex === index
                    ? {
                        ...item,
                        produs_id: product.id,
                        search: product.nume || '',
                        nume: product.nume || '',
                        cod_produs: product.cod_produs || '',
                        serie_produs: product.serie_produs || '',
                        ean: product.ean || '',
                        imagine: product.imagine || '',
                        garantie: product.garantie || '',
                        termen_livrare: product.termen_livrare || '',
                        furnizori: productSuppliers.map((supplier) => ({
                            id: supplier.id || null,
                            furnizor_id: supplier.furnizor_id || '',
                            furnizor_nume: supplier.furnizor_nume || '',
                            furnizor_logo: supplier.furnizor_logo || '',
                            link_produs: supplier.link_produs || '',
                            pret_furnizor: supplier.pret_furnizor || '',
                            cantitate_disponibila: supplier.cantitate_disponibila ?? '',
                            cantitate: 1
                        }))
                    }
                    : item
            )
        )

        setProductSearchResults((prev) => ({
            ...prev,
            [index]: []
        }))
    }
    async function getAllProductsForOrderDetails() {
        try {
            const response = await fetch(GET_PRODUCTS_API_URL)
            const data = await response.json()

            setAllProducts(Array.isArray(data.products) ? data.products : data.produse || [])
        } catch (err) {
            console.error('GET PRODUCTS ERROR:', err)
            setAllProducts([])
        }
    }

    // function searchModalProduct(value) {
    //     setProductForm((prev) => ({
    //         ...prev,
    //         search: value,
    //         nume: value,
    //         produs_id: null
    //     }))

    //     const cleanValue = value.trim().toLowerCase()

    //     if (cleanValue.length < 2) {
    //         setProductSearchResults([])
    //         return
    //     }

    //     const results = allProducts
    //         .filter((product) => {
    //             const searchableText = [
    //                 product.nume,
    //                 product.cod_produs,
    //                 product.serie_produs,
    //                 product.ean
    //             ]
    //                 .filter(Boolean)
    //                 .join(' ')
    //                 .toLowerCase()

    //             return searchableText.includes(cleanValue)
    //         })
    //         .slice(0, 30)

    //     setProductSearchResults(results)
    // }

    // function selectModalProduct(product) {
    //     const suppliers = Array.isArray(product.furnizori) ? product.furnizori : []

    //     setProductForm({
    //         produs_id: product.id,
    //         search: product.nume || '',
    //         nume: product.nume || '',
    //         imagine: product.imagine || '',
    //         cod_produs: product.cod_produs || '',
    //         serie_produs: product.serie_produs || '',
    //         ean: product.ean || '',
    //         garantie: product.garantie || '',
    //         termen_livrare: product.termen_livrare || '',
    //         cantitate: 1,
    //         pret_ofertat: ''
    //     })

    //     setProductSuppliersForm(
    //         suppliers.map((supplier) => ({
    //             id: supplier.id || null,
    //             furnizor_id: supplier.furnizor_id || '',
    //             furnizor_nume: supplier.furnizor_nume || '',
    //             furnizor_logo: supplier.furnizor_logo || '',
    //             link_produs: supplier.link_produs || '',
    //             pret_furnizor: supplier.pret_furnizor || '',
    //             cantitate_disponibila: supplier.cantitate_disponibila ?? '',
    //             cantitate: 1
    //         }))
    //     )

    //     setProductSearchResults([])
    // }
    // function updateProductForm(field, value) {
    //     setProductForm((prev) => ({
    //         ...prev,
    //         [field]: value
    //     }))
    // }

    // function updateSupplierForm(index, field, value) {
    //     setProductSuppliersForm((prev) =>
    //         prev.map((supplier, supplierIndex) =>
    //             supplierIndex === index
    //                 ? { ...supplier, [field]: value }
    //                 : supplier
    //         )
    //     )
    // }

    // function addSupplierForm() {
    //     setProductSuppliersForm((prev) => [
    //         ...prev,
    //         {
    //             furnizor_id: '',
    //             link_produs: '',
    //             pret_furnizor: '',
    //             cantitate_disponibila: '',
    //             cantitate: 1
    //         }
    //     ])
    // }

    async function saveProductAndAddToOrder() {
        const validProducts = addProductsForm.filter((product) => product.produs_id)

        if (validProducts.length === 0) {
            alert('Alege cel puțin un produs din căutare.')
            return
        }

        const newOrderProducts = validProducts.map((product, productIndex) => ({
            id: `new-order-product-${Date.now()}-${productIndex}`,
            produs_id: product.produs_id,
            nume: product.nume || '',
            imagine: product.imagine || '',
            cod_produs: product.cod_produs || '',
            serie_produs: product.serie_produs || '',
            ean: product.ean || '',
            garantie: product.garantie || '',
            termen_livrare: product.termen_livrare || '',
            cantitate: Number(product.cantitate || 1),
            pret_ofertat: product.pret_ofertat || null,
            status: 'ofertat',
            furnizori: Array.isArray(product.furnizori)
                ? product.furnizori.map((supplier, supplierIndex) => ({
                    id: supplier.id || `new-supplier-${Date.now()}-${productIndex}-${supplierIndex}`,
                    furnizor_id: supplier.furnizor_id || '',
                    furnizor_nume: supplier.furnizor_nume || '',
                    furnizor_logo: supplier.furnizor_logo || '',
                    link_produs: supplier.link_produs || '',
                    pret_furnizor: supplier.pret_furnizor || null,
                    cantitate_disponibila: supplier.cantitate_disponibila || 0,
                    cantitate: supplier.cantitate || 1
                }))
                : []
        }))

        const updatedProducts = [...produse, ...newOrderProducts]

        await saveOrder(orderStatus, updatedProducts)

        setIsAddProductModalOpen(false)
    }
    const getOrderStatusHistory = useCallback(async () => {
        try {
            const response = await fetch(
                `${GET_ORDER_STATUS_HISTORY_API_URL}?uuid=${encodeURIComponent(orderUuid)}`,
                {
                    method: 'GET'
                }
            )

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Nu am putut încărca istoricul comenzii.')
            }

            setOrderStatusHistory(Array.isArray(data.history) ? data.history : [])
        } catch (err) {
            console.error('GET ORDER STATUS HISTORY ERROR:', err)
            setOrderStatusHistory([])
        }
    }, [orderUuid])
    const getOrder = useCallback(async () => {
        try {
            setLoading(true)
            setError('')

            const response = await fetch(`${GET_ORDER_API_URL}?uuid=${encodeURIComponent(orderUuid)}`, {
                method: 'GET'
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Nu am putut încărca această comandă.')
            }

            setOrderData(data)
            setOrderStatus(data.order?.status || '')
            setPaymentMethod(data.order?.metoda_plata || '')
            setOrderDeliveryTerm(data.order?.termen_livrare || '')
            setOrderCommercialDetailsChanged(false)
            setSelectedProducts([])
            setDirtyProductIds([])
            setBulkProductStatus('ofertat')
            await getOrderStatusHistory()
        } catch (err) {
            console.error('GET ORDER ERROR:', err)
            setError(err.message || 'Nu am putut încărca această comandă.')
        } finally {
            setLoading(false)
        }
    }, [orderUuid, getOrderStatusHistory])

    useEffect(() => {
        getOrder()
    }, [getOrder])
    function toggleProduct(productId) {
        setSelectedProducts((prev) =>
            prev.includes(productId)
                ? prev.filter((id) => id !== productId)
                : [...prev, productId]
        )
    }
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                statusDropdownRef.current &&
                !statusDropdownRef.current.contains(event.target)
            ) {
                setStatusDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])
    function toggleAllProducts() {
        const allIds = produse.map((product) => product.id)

        setSelectedProducts((prev) =>
            prev.length === allIds.length ? [] : allIds
        )
    }

  function buildPayload(nextOrderStatus, nextProducts) {
    return {
        uuid: orderUuid,
        clientId: client.id,
        contactId: order.contact_id || null,
        adresaId: order.adresa_id || null,
        numeComanda: order.nume,
        status: nextOrderStatus,
        notite: order.notite || '',
        produse: nextProducts.map((product) => ({
            produsId: product.produs_id,
            nume: product.nume || '',
            codProdus: product.cod_produs || '',
            ean: product.ean || '',
            garantie: product.garantie || '',
            termenLivrare:
                product.termen_livrare || '',
            cantitate: Number(
                product.cantitate || 1
            ),
            pretOfertat:
                product.pret_ofertat || null,
            status:
                product.status || 'ofertat',
            serii: Array.isArray(product.serii)
                ? product.serii
                : [],
            furnizori: Array.isArray(
                product.furnizori
            )
                ? product.furnizori
                : []
        }))
    }
}
    function toggleOpenProduct(productId) {
        setOpenProducts((prev) =>
            prev.includes(productId)
                ? prev.filter((id) => id !== productId)
                : [...prev, productId]
        )
    }

    async function saveOrder(nextOrderStatus, nextProducts) {
        try {
            setSaving(true)

            const response = await fetch(EDIT_ORDER_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(buildPayload(nextOrderStatus, nextProducts))
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Nu am putut salva modificările.')
            }

            await getOrder()
        } catch (err) {
            console.error('EDIT ORDER ERROR:', err)
            alert(err.message || 'Nu am putut salva modificările.')
        } finally {
            setSaving(false)
        }
    }

 async function saveOrderStatus() {
    try {
        setSavingOrderStatus(true)

        const response = await fetch(
            UPDATE_ORDER_STATUS_HISTORY_API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uuid: orderUuid,
                    status: orderStatus
                })
            }
        )

        const data = await response.json()

        if (!response.ok || !data.success) {
            throw new Error(
                data.message ||
                'Nu am putut salva statusul.'
            )
        }

        setOrderData((prev) => ({
            ...prev,
            order: {
                ...prev.order,
                status: data.status
            }
        }))

        await getOrderStatusHistory()
    } catch (err) {
        console.error(
            'UPDATE ORDER STATUS HISTORY ERROR:',
            err
        )

        alert(
            err.message ||
            'Nu am putut salva statusul.'
        )
    } finally {
        setSavingOrderStatus(false)
    }
}

    async function saveSelectedProductStatus() {
        if (!bulkProductStatus) {
            alert('Alege status pentru produse.')
            return
        }

        if (selectedProducts.length === 0) {
            alert('Selectează cel puțin un produs.')
            return
        }

        const currentProducts = Array.isArray(orderData?.produse)
            ? orderData.produse
            : []

        const updatedProducts = currentProducts.map((product) =>
            selectedProducts.includes(product.id)
                ? {
                    ...product,
                    status: bulkProductStatus
                }
                : product
        )

        setOrderData((prev) => ({
            ...prev,
            produse: updatedProducts
        }))

        await saveOrder(orderStatus, updatedProducts)
    }
    async function generateOfferPdf() {
        try {
            setGeneratingOffer(true)

            const payload = {
                uuid: orderUuid
            }

            if (selectedProducts.length > 0) {
                payload.productIds = selectedProducts
            }

            const token = localStorage.getItem('techdelivery_token')

            const response = await fetch(GENERATE_OFFER_PDF_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token
                        ? {
                            Authorization: `Bearer ${token}`
                        }
                        : {})
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(
                    data.message ||
                    'Nu am putut genera oferta.'
                )
            }

            if (!data.downloadUrl) {
                throw new Error(
                    'Lambda nu a returnat linkul documentului.'
                )
            }

            window.open(
                data.downloadUrl,
                '_blank',
                'noopener,noreferrer'
            )
        } catch (err) {
            console.error('GENERATE OFFER PDF ERROR:', err)

            alert(
                err.message ||
                'Nu am putut genera oferta.'
            )
        } finally {
            setGeneratingOffer(false)
        }
    }
    if (loading) {
        return <section className="clientDetailsPage">Se încarcă comanda...</section>
    }

    if (error) {
        return <section className="clientDetailsPage">{error}</section>
    }

    if (!orderData?.order) {
        return <section className="clientDetailsPage">Comanda nu a fost găsită.</section>
    }

    const order = orderData.order || {}
    const client = orderData.client || {}
    const contact = orderData.contact || {}
    const adresa = orderData.adresa || {}
    const produse = Array.isArray(orderData.produse) ? orderData.produse : []
    const hasOfferedProducts = produse.some(
        (product) => product.status === 'ofertat'
    )

    const canGenerateOffer =
        hasOfferedProducts ||
        selectedProducts.length > 0

    const sortedProduse = [...produse].sort((a, b) => {
        const statusA = PRODUCT_STATUS_ORDER[a.status] || 99
        const statusB = PRODUCT_STATUS_ORDER[b.status] || 99

        if (statusA !== statusB) {
            return statusA - statusB
        }

        return Number(a.id || 0) - Number(b.id || 0)
    })

    const filteredProduse =
        productStatusFilter === 'toate'
            ? sortedProduse
            : sortedProduse.filter((product) => product.status === productStatusFilter)

    const totalProductPages = Math.max(
        1,
        Math.ceil(filteredProduse.length / productsPerPage)
    )

    const paginatedProduse = filteredProduse.slice(
        (productsPage - 1) * productsPerPage,
        productsPage * productsPerPage
    )
    function getAverageSupplierPrice(product) {
        if (!Array.isArray(product.furnizori) || product.furnizori.length === 0) {
            return 0
        }

        return Math.max(
            ...product.furnizori.map(
                (supplier) => Number(supplier.pret_furnizor) || 0
            )
        )
    }

    function hasSupplierPrice(product) {
        if (!Array.isArray(product.furnizori) || product.furnizori.length === 0) {
            return false
        }

        return product.furnizori.some(
            (supplier) =>
                supplier.pret_furnizor !== null &&
                supplier.pret_furnizor !== undefined &&
                supplier.pret_furnizor !== '' &&
                Number(supplier.pret_furnizor) > 0
        )
    }
    function getProductProfit(product) {
        const supplierPrice = getAverageSupplierPrice(product)
        const finalPrice = Number(product.pret_ofertat || 0)
        const quantity = Number(product.cantitate || 1)

        return (finalPrice - supplierPrice) * quantity
    }

    function getProfitPerProduct(product) {
        const supplierPrice = getAverageSupplierPrice(product)
        const finalPrice = Number(product.pret_ofertat || 0)

        return finalPrice - supplierPrice
    }

    const acceptedProducts = produse.filter((product) =>
        ACCEPTED_PRODUCT_STATUSES.includes(product.status)
    )

    const acceptedProductsCount = acceptedProducts.length
    const acceptedProductsProfit = acceptedProducts.reduce(
        (total, product) => total + getProductProfit(product),
        0
    )

    const acceptedProductsProfitWithVat = acceptedProductsProfit * 1.21
    function markProductAsChanged(productId) {
        setDirtyProductIds((prev) =>
            prev.includes(productId)
                ? prev
                : [...prev, productId]
        )
    }

    async function saveProductChanges(productId) {
        const currentProducts = Array.isArray(orderData?.produse)
            ? orderData.produse
            : []

        if (currentProducts.length === 0) {
            return
        }

        await saveOrder(orderStatus, currentProducts)
    }
    function updateProductField(productId, field, value) {
        setOrderData((prev) => ({
            ...prev,
            produse: prev.produse.map((product) =>
                product.id === productId
                    ? { ...product, [field]: value }
                    : product
            )
        }))

        markProductAsChanged(productId)
    }
    function updateSupplierField(productId, supplierId, field, value) {
        setOrderData((prev) => ({
            ...prev,
            produse: prev.produse.map((product) =>
                product.id === productId
                    ? {
                        ...product,
                        furnizori: Array.isArray(product.furnizori)
                            ? product.furnizori.map((supplier) =>
                                supplier.id === supplierId
                                    ? { ...supplier, [field]: value }
                                    : supplier
                            )
                            : []
                    }
                    : product
            )
        }))

        markProductAsChanged(productId)
    }

    function getSupplierTotal(supplier) {
        return Number(supplier.pret_furnizor || 0) * Number(supplier.cantitate || 1)
    }

async function saveOrderCommercialDetails() {
    try {
        setSavingCommercialDetails(true)

        const response = await fetch(
            UPDATE_ORDER_STATUS_HISTORY_API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uuid: orderUuid,
                    metodaPlata:
                        paymentMethod || null,
                    termenLivrareComanda:
                        orderDeliveryTerm || null
                })
            }
        )

        const data = await response.json()

        if (!response.ok || !data.success) {
            throw new Error(
                data.message ||
                'Nu am putut salva metoda de plată și termenul de livrare.'
            )
        }

        setOrderData((prev) => ({
            ...prev,
            order: {
                ...prev.order,
                metoda_plata:
                    data.metoda_plata,
                termen_livrare:
                    data.termen_livrare
            }
        }))

        setPaymentMethod(
            data.metoda_plata || ''
        )

        setOrderDeliveryTerm(
            data.termen_livrare || ''
        )

        setOrderCommercialDetailsChanged(false)
    } catch (err) {
        console.error(
            'UPDATE ORDER COMMERCIAL DETAILS ERROR:',
            err
        )

        alert(
            err.message ||
            'Nu am putut salva metoda de plată și termenul de livrare.'
        )
    } finally {
        setSavingCommercialDetails(false)
    }
}

function showCopyToast(message) {
    const toast = document.createElement('div')
    toast.className = 'copyToast'
    toast.textContent = message

    document.body.appendChild(toast)

    setTimeout(() => {
        toast.classList.add('show')
    }, 10)

    setTimeout(() => {
        toast.classList.remove('show')

        setTimeout(() => {
            toast.remove()
        }, 250)
    }, 1800)
}

async function copyOfferProduct(product) {
    const text = [
        product.nume || '-',
        `Cod produs: ${product.cod_produs || '-'}`,
        `Preț fără TVA: ${
            product.pret_ofertat !== null &&
            product.pret_ofertat !== undefined &&
            product.pret_ofertat !== ''
                ? `${Number(product.pret_ofertat).toFixed(2)} RON`
                : '-'
        }`,
        `Garanție: ${product.garantie || '-'}`,
        `Termen de livrare: ${product.termen_livrare || '-'}`
    ].join('\n')

    await navigator.clipboard.writeText(text)
    showCopyToast('Produs copiat')
}

async function copySelectedOfferProducts() {
    const productsToCopy = produse.filter((product) =>
        selectedProducts.includes(product.id)
    )

    if (productsToCopy.length === 0) {
        return
    }

    const text = productsToCopy
        .map((product, index) =>
            [
                `${index + 1}. ${product.nume || '-'}`,
                `Cod produs: ${product.cod_produs || '-'}`,
                `Preț fără TVA: ${
                    product.pret_ofertat !== null &&
                    product.pret_ofertat !== undefined &&
                    product.pret_ofertat !== ''
                        ? `${Number(product.pret_ofertat).toFixed(2)} RON`
                        : '-'
                }`,
                `Garanție: ${product.garantie || '-'}`,
                `Termen de livrare: ${product.termen_livrare || '-'}`
            ].join('\n')
        )
        .join('\n\n')

    await navigator.clipboard.writeText(text)

    showCopyToast(
        productsToCopy.length === 1
            ? 'Produs copiat'
            : `${productsToCopy.length} produse copiate`
    )
}
    return (

        <section className="clientDetailsPage">
            <div className="clientBreadcrumb">
                <button
                    type="button"
                    className="orderClientButton"
                    onClick={() => navigate(`/clienti/${clientSlug}`)}
                >
                    <div className="orderClientText">
                        <strong>{client.nume || '-'}</strong>
                    </div>
                </button>

                <span>›</span>

                <strong>{order.nume || 'Comandă'}</strong>
            </div>

            <div className="orderDetailsHeader">
                <button
                    type="button"
                    className="orderBackButton"
                    onClick={() => navigate(`/clienti/${clientSlug}`)}
                >
                    ‹
                </button>

                <div className="orderTitleBox">
                    <div className="orderTitleLine">
                        <h1>{order.nume || 'Comandă'}</h1>

                    </div>

                    <p>Creată la: {formatDate(order.solicitare_data)}</p>
                </div>

                <div className="orderHeaderActions">
                    <div className="customStatusSelect" ref={statusDropdownRef}>
                        <button
                            type="button"
                            className="customStatusTrigger"
                            onClick={() => setStatusDropdownOpen((prev) => !prev)}
                        >
                            <span className={`statusIcon statusIcon-${orderStatus}`}>
                                {ORDER_STATUS_ICONS[orderStatus]}
                            </span>

                            <span className="statusSelectedLabel">
                                {ORDER_STATUS_LABELS[orderStatus] || orderStatus}
                            </span>

                            <span className={`statusChevron ${statusDropdownOpen ? 'statusChevronOpen' : ''}`}></span>
                        </button>

                        {statusDropdownOpen && (
                            <div className="customStatusMenu">
                                {ORDER_STATUSES.map((status) => (
                                    <button
                                        key={status}
                                        type="button"
                                        className={`customStatusOption ${orderStatus === status ? 'active' : ''}`}
                                        onClick={() => {
                                            setOrderStatus(status)
                                            setStatusDropdownOpen(false)
                                        }}
                                    >
                                        <span className={`statusIcon statusIcon-${status}`}>
                                            {ORDER_STATUS_ICONS[status]}
                                        </span>

                                        <span className="statusOptionLabel">
                                            {ORDER_STATUS_LABELS[status]}
                                        </span>

                                        {orderStatus === status && <span className="statusCheck">✓</span>}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                 <button
    type="button"
    className="statusSaveButton"
    disabled={savingOrderStatus}
    onClick={saveOrderStatus}
    title="Salvează statusul"
>
    {savingOrderStatus ? '…' : '✓'}
</button>
                </div>
            </div>

            <div className="orderInfoBar">
                <div className="orderInfoBlock">
                    <div className="orderClientInfo">
                        <div className="orderClientLogo">
                            {client.logo ? (
                                <img src={client.logo} alt={client.nume} />
                            ) : (
                                <span>{(client.nume || '?').charAt(0)}</span>
                            )}
                        </div>

                        <div className="orderClientText">
                            <strong>{client.nume || '-'}</strong>
                            <span>CUI {client.cui || '-'}</span>
                        </div>
                    </div>
                 <div className="orderCommercialDetails">
    <small className="orderNumber">
        Comandă #{order.order_number}
    </small>

    <div className="orderCommercialRow">
        <label className="orderCommercialField">
            <span>Metodă de plată</span>

            <select
                value={paymentMethod}
                onChange={(event) => {
                    setPaymentMethod(
                        event.target.value
                    )

                    setOrderCommercialDetailsChanged(
                        true
                    )
                }}
            >
                {PAYMENT_METHOD_OPTIONS.map(
                    (option) => (
                        <option
                            key={
                                option.value ||
                                'empty-payment'
                            }
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    )
                )}
            </select>
        </label>

        <label className="orderCommercialField">
            <span>Termen livrare</span>

            <select
                value={orderDeliveryTerm}
                onChange={(event) => {
                    setOrderDeliveryTerm(
                        event.target.value
                    )

                    setOrderCommercialDetailsChanged(
                        true
                    )
                }}
            >
                {DELIVERY_TERM_OPTIONS.map(
                    (option) => (
                        <option
                            key={
                                option.value ||
                                'empty-delivery'
                            }
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    )
                )}
            </select>
        </label>

        {orderCommercialDetailsChanged && (
            <button
                type="button"
                className="saveProductRowButton"
                disabled={savingCommercialDetails}
                onClick={
                    saveOrderCommercialDetails
                }
                title="Salvează metoda de plată și termenul de livrare"
                aria-label="Salvează metoda de plată și termenul de livrare"
            >
                {savingCommercialDetails
                    ? '…'
                    : '✓'}
            </button>
        )}
    </div>
</div>
                </div>
                <div className="orderInfoBlock">
                    <strong>👤 {contact.nume || '-'}</strong>
                    <small>{contact.email || contact.telefon || '-'}</small>
                    <strong></strong>
                    <strong>📍 {adresa.nume || '-'}</strong>
                    <small>{adresa.adresa || '-'}</small>

                </div>

                <div className="orderInfoBlock">
                    <strong>Istoric Comandă:</strong>

                    {orderStatusHistory.length === 0 ? (
                        <small>Nu există istoric pentru această comandă.</small>
                    ) : (
                        orderStatusHistory.map((historyItem) => (
                            <small key={historyItem.status}>
                                <b>{ORDER_STATUS_LABELS[historyItem.status] || historyItem.status} -</b>{' '}
                                {formatDate(historyItem.created_at)}
                            </small>
                        ))
                    )}
                </div>

            </div>
            {/* <div className="orderBottomBar">
                <select
                    value={bulkProductStatus}
                    onChange={(event) => setBulkProductStatus(event.target.value)}
                >
                    <option value="">Schimbă statusul</option>

                    {PRODUCT_STATUSES.map((status) => (
                        <option key={status} value={status}>
                            {status}
                        </option>
                    ))}
                </select>

                <button
                    type="button"
                    disabled={saving || selectedProducts.length === 0}
                    onClick={saveSelectedProductStatus}
                >
                    Aplică pe selectate
                </button>
            </div> */}
            <div className="productActionsBar">
                <div className="productStatusFilters">
                    {['toate', ...PRODUCT_STATUSES].map((status) => (
                        <button
                            key={status}
                            type="button"
                            className={productStatusFilter === status ? 'active' : ''}
                            onClick={() => {
                                setProductStatusFilter(status)
                                setProductsPage(1)
                            }}
                        >
                            {PRODUCT_STATUS_LABELS[status]}
                        </button>
                    ))}
                </div>

                <div className="productActionsButtons">
                    {canGenerateOffer && (
                        <button
                            type="button"
                            className="generateOfferButton"
                            disabled={generatingOffer}
                            onClick={generateOfferPdf}
                        >
                            {generatingOffer
                                ? 'Se generează...'
                                : selectedProducts.length > 0
                                    ? `Generează oferta (${selectedProducts.length})`
                                    : 'Generează oferta'}
                        </button>
                    )}

                    <button
                        type="button"
                        className="addOrderProductButton"
                        onClick={openAddProductModal}
                    >
                        + Adaugă produs în comandă
                    </button>
                </div>
            </div>

            <div className="orderProductsTable">
                <div className="orderProductsHead">
                    <span>
                        <label className="coolCheckbox">
                            <input
                                type="checkbox"
                                checked={selectedProducts.length === produse.length && produse.length > 0}
                                onChange={toggleAllProducts}
                            />
                            <span></span>
                        </label>
                    </span>

                    <span className="productHeadWithBulk">
                        <span>Produs</span>

                     {selectedProducts.length > 0 && (
    <div className="inlineBulkStatus">
        <select
            value={bulkProductStatus}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) =>
                setBulkProductStatus(event.target.value)
            }
        >
            {PRODUCT_STATUSES.map((status) => (
                <option key={status} value={status}>
                    {PRODUCT_STATUS_LABELS[status]}
                </option>
            ))}
        </select>

        <button
            type="button"
            className="bulkStatusSaveButton"
            disabled={saving || !bulkProductStatus}
            onClick={(event) => {
                event.stopPropagation()
                saveSelectedProductStatus()
            }}
            title="Aplică statusul pe produsele selectate"
            aria-label="Aplică statusul pe produsele selectate"
        >
            ✓
        </button>

        <button
            type="button"
            className="copyOfferProductButton"
            onClick={(event) => {
                event.stopPropagation()
                copySelectedOfferProducts()
            }}
            title="Copiază produsele selectate"
            aria-label="Copiază produsele selectate"
        >
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1Zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H10V7h9v14Z" />
            </svg>
        </button>
    </div>
)}
                    </span>
                    <span>Cod produs</span>
                    <span>EAN</span>
                    <span>Cantitate</span>
                    <span>Preț furnizor mediu</span>
                    <span>Preț final ofertat</span>
                    <span>Profit / produs</span>
                    <span>Profit Total</span>
                    <span>Garanție</span>
                    <span>Termen livrare</span>
                    <span>Status</span>
                    <span></span>
                </div>


                {filteredProduse.length === 0 ? (
                    <div className="emptyProductsState">
                        Nu există produse cu statusul{' '}
                        <strong>{PRODUCT_STATUS_LABELS[productStatusFilter]}</strong>.
                    </div>
                ) : (
                    paginatedProduse.map((product) => {
                        const isOpen = openProducts.includes(product.id)
                        const isChanged = dirtyProductIds.includes(product.id)

                        return (
                            <div
                                className={`orderProductCard ${isOpen ? 'productCardOpen' : ''}`}
                                key={product.id}
                            >
                                <div
                                    className="orderProductRow"
                                    onClick={() => toggleOpenProduct(product.id)}
                                >
                                    <span onClick={(event) => event.stopPropagation()}>
                                        <label className="coolCheckbox" onClick={(event) => event.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={selectedProducts.includes(product.id)}
                                                onChange={() => toggleProduct(product.id)}
                                            />
                                            <span></span>
                                        </label>
                                    </span>

                                    <span className="orderProductName">
                                        {product.imagine && (
                                            <img src={product.imagine} alt={product.nume} />
                                        )}

                                        <input
                                            className="productLightInput productNameInput"
                                            value={product.nume || ''}
                                            onClick={(event) => event.stopPropagation()}
                                            onChange={(event) => updateProductField(product.id, 'nume', event.target.value)}
                                        />
                                    </span>

                                    <input
                                        className="productLightInput"
                                        value={product.cod_produs || ''}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => updateProductField(product.id, 'cod_produs', event.target.value)}
                                    />

                                    <input
                                        className="productLightInput"
                                        value={product.ean || ''}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => updateProductField(product.id, 'ean', event.target.value)}
                                    />

                                    <input
                                        className="productLightInput"
                                        type="number"
                                        value={product.cantitate || 1}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => updateProductField(product.id, 'cantitate', event.target.value)}
                                    />

                                    <span
                                        className={`readonlyMoney ${!hasSupplierPrice(product) ? 'missingProductPrice' : ''
                                            }`}
                                    >
                                        {getAverageSupplierPrice(product).toFixed(2)} RON
                                    </span>

                                    <input
                                        className={`productLightInput moneyInput ${Number(product.pret_ofertat || 0) === 0
                                            ? 'missingProductPriceInput'
                                            : ''
                                            }`}
                                        type="number"
                                        step="0.01"
                                        value={product.pret_ofertat ?? ''}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) =>
                                            updateProductField(
                                                product.id,
                                                'pret_ofertat',
                                                event.target.value
                                            )
                                        }
                                    />
                                    <span
                                        className={`profitValue ${getProfitPerProduct(product) < 0 ? 'lossValue' : 'profitValuePositive'}`}
                                    >
                                        {getProfitPerProduct(product).toFixed(2)} RON
                                    </span>
                                    <span
                                        className={`profitValue ${getProfitPerProduct(product) < 0 ? 'lossValue' : 'profitValuePositive'}`}
                                    >
                                        {getProductProfit(product).toFixed(2)} RON
                                    </span>



                                    <input
                                        className="productLightInput"
                                        value={product.garantie || ''}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => updateProductField(product.id, 'garantie', event.target.value)}
                                    />

                                    <input
                                        className="productLightInput"
                                        value={product.termen_livrare || ''}
                                        onClick={(event) => event.stopPropagation()}
                                        onChange={(event) => updateProductField(product.id, 'termen_livrare', event.target.value)}
                                    />

                                    <span className={`statusPill status-${product.status}`}>
                                        {product.status}
                                    </span>

                                   <span
    className="productRowActions"
    onClick={(event) => event.stopPropagation()}
>
    {isChanged && (
        <button
            type="button"
            className="saveProductRowButton"
            disabled={saving}
            onClick={() => saveProductChanges(product.id)}
            title="Salvează modificările produsului"
            aria-label="Salvează modificările produsului"
        >
            {saving ? '…' : '✓'}
        </button>
    )}

    <button
        type="button"
        className="copyOfferProductButton"
        onClick={() => copyOfferProduct(product)}
        title="Copiază produsul"
        aria-label="Copiază produsul"
    >
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1Zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H10V7h9v14Z" />
        </svg>
    </button>

    <button
        type="button"
        className="productArrowButton"
        onClick={() => toggleOpenProduct(product.id)}
        aria-label={
            isOpen
                ? 'Ascunde furnizorii'
                : 'Arată furnizorii'
        }
    >
        <span className="productArrow">›</span>
    </button>
</span>
                                </div>

                                {isOpen && (
                                    <div className="orderSuppliersBox">
                                        <div className="orderSuppliersTitle">
                                            <strong>Furnizori ({product.furnizori?.length || 0})</strong>

                                            <button
                                                type="button"
                                                className="addProductSupplierButton"
                                                onClick={(event) => {
                                                    event.stopPropagation()
                                                    // setActiveSupplierProductId(product.id)
                                                    setIsAddSupplierModalOpen(true)
                                                }}
                                            >
                                                + Furnizor
                                            </button>
                                        </div>

                                        {Array.isArray(product.furnizori) && product.furnizori.length > 0 ? (
                                            <div className="orderSuppliersTable">
                                                <div className="orderSuppliersGrid orderSuppliersHead">
                                                    <span>Furnizor</span>
                                                    <span>Link produs furnizor</span>
                                                    <span>Stoc disponibil</span>
                                                    <span>Preț furnizor</span>
                                                    <span>Cantitate propusă</span>
                                                    <span>Total</span>
                                                </div>

                                                {product.furnizori.map((supplier) => (
                                                    <div className="orderSuppliersGrid" key={supplier.id}>
                                                        <div className="productSupplierIdentity">
                                                            <div className="productSupplierLogo">
                                                                {supplier.furnizor_logo ? (
                                                                    <img src={supplier.furnizor_logo} alt={supplier.furnizor_nume} />
                                                                ) : (
                                                                    <span>{(supplier.furnizor_nume || '?').charAt(0)}</span>
                                                                )}
                                                            </div>

                                                            <strong>{supplier.furnizor_nume || '-'}</strong>
                                                        </div>

                                                        <span>
                                                            {supplier.link_produs ? (
                                                                <a
                                                                    href={supplier.link_produs}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="productLinkButton"
                                                                >
                                                                    Vezi produs

                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        width="14"
                                                                        height="14"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                    >
                                                                        <path d="M14 3h7v7" />
                                                                        <path d="M10 14L21 3" />
                                                                        <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
                                                                    </svg>
                                                                </a>
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </span>

                                                        <input
                                                            className="supplierLightInput"
                                                            type="number"
                                                            value={supplier.cantitate_disponibila ?? ''}
                                                            onChange={(event) =>
                                                                updateSupplierField(product.id, supplier.id, 'cantitate_disponibila', event.target.value)
                                                            }
                                                        />

                                                        <input
                                                            className="supplierLightInput"
                                                            type="number"
                                                            step="0.01"
                                                            value={supplier.pret_furnizor || ''}
                                                            onChange={(event) =>
                                                                updateSupplierField(product.id, supplier.id, 'pret_furnizor', event.target.value)
                                                            }
                                                        />

                                                        <input
                                                            className="supplierLightInput"
                                                            type="number"
                                                            value={supplier.cantitate || 1}
                                                            onChange={(event) =>
                                                                updateSupplierField(product.id, supplier.id, 'cantitate', event.target.value)
                                                            }
                                                        />

                                                        <strong className="supplierTotal">
                                                            {getSupplierTotal(supplier).toFixed(2)} RON
                                                        </strong>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="emptySupplierRow">
                                                Nu există furnizori pentru acest produs.
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )
                    })
                )}

            </div>

            <div className="acceptedProductsSummary">
                <div className="acceptedProductsSummaryItem">
                    <span>Produse</span>
                    <strong>
                        {acceptedProductsCount}{' '}
                        {acceptedProductsCount === 1 ? 'produs' : 'produse'}
                    </strong>
                </div>

                <div className="acceptedProductsSummaryValues">
                    <div className="acceptedProductsSummaryItem">
                        <span>Profit total</span>
                        <strong>
                            {acceptedProductsProfit.toFixed(2)} RON
                        </strong>
                    </div>

                    <div className="acceptedProductsSummaryItem acceptedProductsSummaryVat">
                        <span>Profit total cu TVA</span>
                        <strong>
                            {acceptedProductsProfitWithVat.toFixed(2)} RON
                        </strong>
                    </div>
                </div>
            </div>
            {filteredProduse.length > 0 && (
                <div className="productsPagination orderDetailsPagination">
                    <div className="productsPerPage">
                        <span>Afișează</span>

                        <select
                            value={productsPerPage}
                            onChange={(event) => {
                                setProductsPerPage(Number(event.target.value))
                                setProductsPage(1)
                                setSelectedProducts([])
                                setOpenProducts([])
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>

                        <span>produse</span>
                    </div>

                    <div className="productsPaginationControls">
                        <button
                            type="button"
                            disabled={productsPage === 1}
                            onClick={() => {
                                setProductsPage((prev) => Math.max(1, prev - 1))
                                setSelectedProducts([])
                                setOpenProducts([])
                            }}
                            aria-label="Pagina anterioară"
                        >
                            <span className="paginationArrow">‹</span>
                            <span className="paginationText">Înapoi</span>
                        </button>

                        <span>
                            Pagina {productsPage} din {totalProductPages}
                        </span>

                        <button
                            type="button"
                            disabled={productsPage === totalProductPages}
                            onClick={() => {
                                setProductsPage((prev) =>
                                    Math.min(totalProductPages, prev + 1)
                                )
                                setSelectedProducts([])
                                setOpenProducts([])
                            }}
                            aria-label="Pagina următoare"
                        >
                            <span className="paginationText">Înainte</span>
                            <span className="paginationArrow">›</span>
                        </button>
                    </div>
                </div>
            )}
            <BigModal
                isOpen={isAddProductModalOpen}
                title="Adaugă produse în comandă"
                onClose={() => setIsAddProductModalOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsAddProductModalOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={savingProduct}
                            onClick={saveProductAndAddToOrder}
                        >
                            {savingProduct ? 'Se salvează...' : 'Adaugă produse'}
                        </button>
                    </>
                }
            >
                <div className="orderPremiumModal">
                    <div className="orderPremiumCard orderPremiumProductsCard orderPremiumProductsCardBlue">
                        <div className="orderPremiumStripeHeader">
                            <div className="orderPremiumSectionIcon orderPremiumBlueIcon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M21 8.5 12 3 3 8.5l9 5.5 9-5.5ZM5 10.2V16l7 4.3V14.5L5 10.2Zm14 0-7 4.3v5.8l7-4.3v-5.8Z" />
                                </svg>
                            </div>

                            <h3>Produse</h3>

                            <button
                                type="button"
                                className="orderPremiumAddButton orderPremiumBlueAddButton"
                                onClick={addEmptyProductToOrderModal}
                            >
                                + Adaugă produs
                            </button>
                        </div>

                        {addProductsForm.length > 0 && (
                            <div className="orderPremiumProductsOfertaHead">
                                <span>Produs</span>
                                <span>Cod produs</span>
                                <span>EAN</span>
                                <span>Cantitate</span>
                                <span>Cost achiziție</span>
                                <span>Preț final ofertat</span>
                                <span></span>
                                <span></span>
                            </div>
                        )}

                        <div className="orderPremiumOfertaRows">
                            {addProductsForm.map((product, index) => {
                                const productKey = product.tempId || index
                                // const suppliersCollapsed = collapsedSupplierSections[productKey]

                                return (
                                    <div className="orderPremiumOfertaProductCard" key={productKey}>
                                        <div className="orderPremiumOfertaProductRow">
                                            <label className="orderPremiumProductSearchCell">
                                                <div className="orderPremiumOfertaProductIdentity">
                                                    <div className="orderPremiumOfertaProductImage">
                                                        {product.imagine ? (
                                                            <img src={product.imagine} alt={product.search || 'Produs'} />
                                                        ) : (
                                                            <span>{String(product.search || '?').charAt(0).toUpperCase()}</span>
                                                        )}
                                                    </div>

                                                    <div className="productSmartSearch">
                                                        <input
                                                            className="productLightInput productNameInput"
                                                            type="text"
                                                            value={product.search || ''}
                                                            onChange={(event) => searchAddOrderProduct(index, event.target.value)}
                                                            placeholder="Caută produs."
                                                            autoComplete="off"
                                                        />

                                                        {String(product.search || '').trim().length >= 2 &&
                                                            productSearchResults[index]?.length > 0 && (
                                                                <div className="productSmartDropdown">
                                                                    {productSearchResults[index].map((result) => (
                                                                        <button
                                                                            type="button"
                                                                            key={result.id}
                                                                            onClick={() => selectAddOrderProduct(index, result)}
                                                                        >
                                                                            <div className="productSmartImage">
                                                                                {result.imagine ? (
                                                                                    <img src={result.imagine} alt={result.nume} />
                                                                                ) : (
                                                                                    <span>{String(result.nume || '?').charAt(0).toUpperCase()}</span>
                                                                                )}
                                                                            </div>

                                                                            <div className="productSmartInfo">
                                                                                <strong>{result.nume}</strong>
                                                                                <small>
                                                                                    {result.cod_produs || '-'} | {result.ean || '-'} | {result.serie_produs || '-'}
                                                                                </small>
                                                                            </div>
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </label>

                                            <input
                                                className="productLightInput"
                                                value={product.cod_produs || ''}
                                                onChange={(event) => updateAddProductField(index, 'cod_produs', event.target.value)}
                                            />

                                            <input
                                                className="productLightInput"
                                                value={product.ean || ''}
                                                onChange={(event) => updateAddProductField(index, 'ean', event.target.value)}
                                            />

                                            <input
                                                className="productLightInput"
                                                type="number"
                                                value={product.cantitate || 1}
                                                onChange={(event) => updateAddProductField(index, 'cantitate', event.target.value)}
                                            />

                                            <input
                                                className="productLightInput"
                                                type="number"
                                                step="0.01"
                                                value={product.pret_furnizor || ''}
                                                disabled
                                            />

                                            <input
                                                className="productLightInput moneyInput"
                                                type="number"
                                                step="0.01"
                                                value={product.pret_ofertat || ''}
                                                onChange={(event) => updateAddProductField(index, 'pret_ofertat', event.target.value)}
                                            />

                                            <button
                                                type="button"
                                                className="orderPremiumCollapseButton"
                                                onClick={() => toggleProductSuppliers(productKey)}
                                            >
                                                ›
                                            </button>

                                            <button
                                                type="button"
                                                className="orderPremiumRemoveButton"
                                                onClick={() => removeProductFromOrderModal(index)}
                                            >
                                                ×
                                            </button>
                                        </div>

                                        {Array.isArray(product.furnizori) &&
                                            product.furnizori.length > 0 &&
                                            !collapsedSupplierSections[productKey] && (
                                                <div className="orderPremiumOfertaSuppliersBox">
                                                    <div className="orderPremiumOfertaSuppliersTitle">
                                                        <strong>Furnizori ({product.furnizori?.length || 0})</strong>
                                                    </div>

                                                    {product.furnizori?.length > 0 ? (
                                                        <div className="orderPremiumOfertaSuppliersTable">
                                                            <div className="orderPremiumOfertaSuppliersGrid orderPremiumOfertaSuppliersHead">
                                                                <span>Furnizor</span>
                                                                <span>Link produs furnizor</span>
                                                                <span>Stoc disponibil</span>
                                                                <span>Preț furnizor</span>
                                                            </div>

                                                            {product.furnizori.map((supplier, supplierIndex) => (
                                                                <div className="orderPremiumOfertaSuppliersGrid" key={`${productKey}-${supplierIndex}`}>
                                                                    <div className="productSupplierIdentity">
                                                                        <div className="productSupplierLogo">
                                                                            {supplier.furnizor_logo ? (
                                                                                <img src={supplier.furnizor_logo} alt={supplier.furnizor_nume} />
                                                                            ) : (
                                                                                <span>{String(supplier.furnizor_nume || '?').charAt(0)}</span>
                                                                            )}
                                                                        </div>

                                                                        <strong>{supplier.furnizor_nume || '-'}</strong>
                                                                    </div>

                                                                    <div className="supplierLinkInput">
                                                                        <button
                                                                            type="button"
                                                                            className="supplierLinkButton"
                                                                            disabled={!supplier.link_produs}
                                                                            onClick={() => {
                                                                                if (supplier.link_produs) {
                                                                                    window.open(supplier.link_produs, '_blank', 'noopener,noreferrer')
                                                                                }
                                                                            }}
                                                                        >
                                                                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                                                                                <path d="M14 3h7v7" />
                                                                                <path d="M10 14L21 3" />
                                                                                <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
                                                                            </svg>
                                                                        </button>

                                                                        <input
                                                                            className="supplierLightInput"
                                                                            value={supplier.link_produs || ''}
                                                                            onChange={(event) =>
                                                                                updateAddProductSupplier(index, supplierIndex, 'link_produs', event.target.value)
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <input
                                                                        className="supplierLightInput"
                                                                        type="number"
                                                                        value={supplier.cantitate_disponibila ?? ''}
                                                                        onChange={(event) =>
                                                                            updateAddProductSupplier(index, supplierIndex, 'cantitate_disponibila', event.target.value)
                                                                        }
                                                                    />

                                                                    <input
                                                                        className="supplierLightInput"
                                                                        type="number"
                                                                        step="0.01"
                                                                        value={supplier.pret_furnizor || ''}
                                                                        onChange={(event) =>
                                                                            updateAddProductSupplier(index, supplierIndex, 'pret_furnizor', event.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="emptySupplierRow">
                                                            Alege un produs ca să vezi furnizorii.
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                )
                            })}
                        </div>

                        {addProductsForm.length === 0 && (
                            <button
                                type="button"
                                className="emptyProductButton"
                                onClick={addEmptyProductToOrderModal}
                            >
                                + Adaugă produs
                            </button>
                        )}
                    </div>
                </div>

            </BigModal>
            <MediumModal
                isOpen={isAddSupplierModalOpen}
                title="Adaugă furnizor pentru produs"
                onClose={() => setIsAddSupplierModalOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsAddSupplierModalOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            onClick={() => {
                                setIsAddSupplierModalOpen(false)
                            }}
                        >
                            Adaugă furnizor
                        </button>
                    </>
                }
            >
                <div className="productForm">
                    Modal furnizor aici.
                </div>
            </MediumModal>
        </section>
    )
}

export default OrderDetails